enum DealPages {
  SEARCH = "Search",
  HOME = "Homepage",
  CATEGORY = "Category",
  PERK = "Perk"
}

export default DealPages
